import {Component, forwardRef, Host, Input, Optional, SkipSelf} from '@angular/core';
import {ControlContainer, NG_VALUE_ACCESSOR} from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';

import * as moment from 'moment';

import {DatepickerComponent} from '../../components/datepicker';

import {environment} from '../../../../environments/environment';

@Component({
    selector: 'app-lockable-datepicker',
    templateUrl: './lockable-datepicker.component.html',
    styleUrls: ['./lockable-datepicker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LockableDatepickerComponent),
            multi: true
        },
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

        {
            provide: MAT_DATE_FORMATS, useValue: {
                parse: {
                    dateInput: environment.dateFormat,
                },
                display: {
                    dateInput: environment.dateFormat,
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: environment.dateFormat,
                    monthYearA11yLabel: 'MMMM YYYY',
                },
            }
        }
    ]
})
export class LockableDatepickerComponent extends DatepickerComponent {
    @Input() public leftAligned: boolean;

    constructor(
        @Optional() @Host() @SkipSelf()
        protected controlContainer: ControlContainer
    ) {
        super(controlContainer);
    }

    onSlideToggleChange(result: boolean) {
        if (result) {
            this.onChange(null);
            this.resetDatepicker();
        } else {
            const date = moment();

            const isoDate = this.setDate(date);

            this.writeValue(isoDate);
            this.onChange(isoDate);
        }

        this.control.disabled = result;
    }

    getTexts(): [string, string] {
        if (
            this.control.more &&
            this.control.more.hasOwnProperty('texts') &&
            Array.isArray(this.control.more.texts) &&
            this.control.more.texts.length === 2
        ) {
            return [this.control.more.texts[0], this.control.more.texts[1]];
        }

        return ['', ''];
    }
}
